import { Button as MuiButton, ButtonProps, darken } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

export type ButtonCotizadorVariant = "primary" | "link";

interface Props extends Omit<ButtonProps, "variant" | "color"> {
  variant: ButtonCotizadorVariant;
}

/**
 * Botones del cotizador en el diseño:
 * - `primary`: `.btn.btn-primary.btn-lg.quote-hero-cta` — 44px, radio 6, `primary.main` que se
 *   oscurece en hover, con flecha al final.
 * - `link`: acción secundaria como enlace subrayado (descarga de la tabla de amortización).
 */
export const ButtonCotizador = ({ variant, children, sx, ...rest }: Props) => (
  <MuiButton
    variant={variant === "primary" ? "contained" : "text"}
    disableElevation
    disableRipple={variant === "link"}
    endIcon={variant === "primary" ? <ArrowForward sx={{ fontSize: "16px !important" }} /> : undefined}
    sx={[
      { textTransform: "none", fontFamily: (theme) => theme.typography.fontFamily, whiteSpace: "nowrap" },
      variant === "primary"
        ? {
            height: 44,
            px: "20px",
            borderRadius: "6px",
            fontSize: 14,
            fontWeight: 500,
            letterSpacing: "-0.005em",
            bgcolor: "primary.main",
            color: "#fff",
            transition: "transform .15s ease, background-color .18s ease",
            "&:hover": { bgcolor: (theme) => darken(theme.palette.primary.main, 0.3), transform: "translateY(-1px)" },
            "&:active": { transform: "translateY(0) scale(.985)" },
            "&.Mui-disabled": { bgcolor: "primary.main", color: "#fff", opacity: 0.4 },
          }
        : {
            p: 0,
            minWidth: 0,
            fontSize: 13,
            fontWeight: 400,
            // El enlace puede ser largo: se parte en varias líneas en vez de ensanchar la pantalla en móvil.
            whiteSpace: "normal",
            textAlign: "left",
            color: "primary.main",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            "&:hover": { bgcolor: "transparent", textDecoration: "underline", color: "primary.dark" },
          },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...rest}
  >
    {children}
  </MuiButton>
);
